import TodosBeta from './TodosBeta';
import TodosPartnership from './TodosPartnership';
import TodosReview from './TodosReview';

export const STATUSES = Object.freeze({
  private: 'build' as const,
  pending: 'review' as const,
  beta: 'beta' as const,
  public: 'partnered' as const,
});

export const PublishingSteps = Object.freeze([
  {
    label: STATUSES.private,
    status: 'private' as const,
    TodosComponent: () => null,
  },
  {
    label: STATUSES.pending,
    status: 'pending' as const,
    TodosComponent: TodosReview,
  },
  {
    label: STATUSES.beta,
    status: 'beta' as const,
    TodosComponent: TodosBeta,
  },
  {
    label: STATUSES.public,
    status: 'public' as const,
    TodosComponent: TodosPartnership,
  },
]);
